<template>
  <BaseNoticeItem
    :button-text="$t('Edit profile now')"
    :button-url="buttonUrl"
    :status="$t('Information missing')"
  >
    <template #head>
      <strong>{{ head }}</strong>
    </template>
    <template #body>
      <p>
        {{ body }}
      </p>
      <FreelancerBusinessEntityAlertDkBody v-if="market === 'DK'" />
      <FreelancerBusinessEntityAlertUkBody v-if="market === 'UK'" />
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import { computed } from 'vue'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import FreelancerBusinessEntityAlertDkBody from '@/components/compliances/BusinessEntity/alerts/FreelancerBusinessEntityAlertDkBody.vue'
import FreelancerBusinessEntityAlertUkBody from '@/components/compliances/BusinessEntity/alerts/FreelancerBusinessEntityAlertUkBody.vue'
import { useMarketDependentValue } from '@/composables/markets'
import { useRedirectUri } from '@/composables/redirectUri'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const props = defineProps({
  market: {
    type: String,
    default: null,
  },
})

const { $t } = useTranslation()

const { redirectUri } = useRedirectUri()

const buttonUrl = computed(() => {
  const path = laravelNamedRoute(namedRoutes.frontend.user.profile.edit, {
    redirect_uri: redirectUri,
  })
  return `${path}#business-entity`
})

const { marketValue: head } = useMarketDependentValue(
  props.market,
  {
    CA: $t('Your profile is missing some tax information'),
    DK: $t('You do not have a valid CVR-number on your profile'),
    UK: $t('On this job you need to bill through a business.'),
  },
  $t('Your profile is missing information about your business'),
)

const { marketValue: body } = useMarketDependentValue(
  props.market,
  {
    AU: $t(
      'In order to create bills with correct business information, you will need to edit your profile and confirm your business entity setup and if relevant whether you are registered for GST or not.',
    ),
    SG: $t(
      'In order to create bills with correct business information, you will need to edit your profile and confirm your business entity setup and if relevant whether you are registered for GST or not.',
    ),
    CA: $t(
      'When you accept a job from a Canada based client using Worksome’s platform, you must fill out additional details regarding your setup for paying Canadian sales tax (GST/HST registration).',
    ),
    US: $t(
      'In order to create bills with correct business information, you will need to confirm your business entity setup and provide more details, such as proof of business registration or sales tax registration status.',
    ),
  },
  $t(
    'In order to create bills with correct business information, you will need to edit your profile and confirm your business entity setup and if relevant whether you are registered for VAT or not.',
  ),
)
</script>
